// extracted by mini-css-extract-plugin
export default {"burger":"styles_burger__pfaKq"};